<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M16 13.333A4.667 4.667 0 1016 4a4.667 4.667 0 000 9.333zm-10 2h1.24A6.645 6.645 0 005.333 20v6.667h-1c-.92 0-1.667-.747-1.667-1.667v-6.333A3.333 3.333 0 016 15.333zm21.667 11.334h-1V20a6.645 6.645 0 00-1.906-4.667h1.24a3.333 3.333 0 013.333 3.334V25c0 .92-.747 1.667-1.667 1.667zM7.334 20A4.667 4.667 0 0112 15.333h8A4.667 4.667 0 0124.667 20v7a1 1 0 01-1 1H8.334a1 1 0 01-1-1v-7zm22-10a3.333 3.333 0 11-6.667 0 3.333 3.333 0 016.667 0zM6 13.333a3.333 3.333 0 100-6.666 3.333 3.333 0 000 6.666z"/></svg>
</template>

<script>
export default {
  name: 'userPeopleFilled'
}
</script>
